export default {
  badgeType: 'Notifications',
  unread: '{{count}} unread',
  unread_plural: '{{count}} unread',
};
